module.exports = __webpack_public_path__ + "img/stanley-smc.638b7918.jpg";